import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import { I18N_STORAGE_KEY } from "./constants";

import commonEs from "./locales/es/common.json";
import launcherEs from "./locales/es/launcher.json";
import aboutEs from "./locales/es/about.json";
import shareEs from "./locales/es/share.json";
import feedbackEs from "./locales/es/feedback.json";

import commonEn from "./locales/en/common.json";
import launcherEn from "./locales/en/launcher.json";
import aboutEn from "./locales/en/about.json";
import shareEn from "./locales/en/share.json";
import feedbackEn from "./locales/en/feedback.json";

const resources = {
  es: {
    common: commonEs,
    launcher: launcherEs,
    about: aboutEs,
    share: shareEs,
    feedback: feedbackEs,
  },
  en: {
    common: commonEn,
    launcher: launcherEn,
    about: aboutEn,
    share: shareEn,
    feedback: feedbackEn,
  },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: "es",
    supportedLngs: ["es", "en"],
    nonExplicitSupportedLngs: true,
    ns: ["common", "launcher", "about", "share", "feedback"],
    defaultNS: "common",
    interpolation: { escapeValue: false },
    detection: {
      order: ["localStorage", "navigator"],
      lookupLocalStorage: I18N_STORAGE_KEY,
      caches: ["localStorage"],
    },
  });

export default i18n;
